export enum Gender {
    Male = 1,
    Female = 2
}
export enum Distance {
    Closest = 1,
    Farest = 2
}
export enum PriceRange {
    LowToHigh = 1,
    HighToLow = 2
}
export enum Rate {
    FiveToZero = 1,
    ZeroToFive = 2
}